/* ==========================================================================
   go-ingredient-detail.js
   Flechas prev/next para el carrusel de ingredientes (scroll por ancho de
   card). Deshabilita flechas en los extremos. Idempotente + editor Shopify.
   ========================================================================== */
(function () {
  'use strict';

  function initSection(section) {
    if (section.dataset.ingInit === '1') return;
    section.dataset.ingInit = '1';

    var track = section.querySelector('[data-go-ing-track]');
    var prev = section.querySelector('[data-go-ing-prev]');
    var next = section.querySelector('[data-go-ing-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.go-ing__card');
      if (!card) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-go-ingredient]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
